import React, {  useEffect } from 'react'
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../contextos/AuthProvider'
import '../Estilos/EstiloSap.css';
import 'bootstrap/dist/css/bootstrap.css';
import '../New Template/Botones.css';
import '../New Template/Formularios1.css';
import { EncApi } from '../Comunes/Listas';
const GeneralCliente = (props) => {
    const { PerfilUsuario, Token } = useAuth();
    const navigate = useNavigate();

    const Salir = () => {
        navigate("/");
    }
    const Avance = (Codigo) => {
        props.CambiaCia(Codigo)
        navigate("/Clientes/FichaCliente");
    }
    const handleOnSubmit = (e) => {
        console.log("in submit");
        if (e.which === '13') {
            e.preventDefault();
        }
        e.preventDefault();
    };


    const [Gestor, setGestor] = React.useState({
       
        NombreCliente: '',
        Cedula: '',
        Codigo: ''
    });
    const CambiaDatosGestor = (e) => {

        const { className, name, value, type } = e.target;
       
        if (className === 'ck') {

            e.target.checked = false;
        }
        setGestor({ ...Gestor, [name]: (type === 'number') ? parseInt(value) : value });
    }
    const [LosClientes, setLosClientes] = React.useState([]);
    const cargandoClientes = async () => {
        //console.log(await Token);

        
        await fetch('https://smartfecr.com:2020/SmartContrackBack/api/Socios/BusquedaCliente?IdCia=' + PerfilUsuario.IdCia +'&Criterio=' + Gestor.NombreCliente, EncApi(Token)
        ).then(response => response.json())
            .then(json => {
                //  console.log(json)
                setLosClientes(json)
                let Limpia = {
                    IdCia: PerfilUsuario.IdCia,
                    NombreCliente: '',
                    Cedula: '',
                    Codigo: ''
                }
                setGestor(Limpia)
            })
    }

    useEffect(() => {
        if (PerfilUsuario) {
            setGestor({
                ...Gestor,
                "IdCia": PerfilUsuario.IdCia,
                "NombreCliente": '',
                "Cedula": '',
                "Codigo": ''
            });
        }

        // eslint-disable-next-line
    }, [])

    if (PerfilUsuario) {
        return <div className='main-block'>
            <div className="form" onSubmit={(e) => handleOnSubmit(e)}>
            <div className='formadoShadow'>

                <div className='tituloPantalla'>
                <p style={{ display: 'inline-block' }}> Administración Datos Clientes</p>
                <button className="botonCerrar" style={{ backgroundColor: '#f3f3f3', width: '50px' }} id="SalirHome" onClick={Salir} name="SalirHome"><i className="fa fa-times"></i></button>
                </div>

                <div className="row">
                
                <div className="col-50">
                    <span className="col-form-span" >Referencia Búsqueda </span>
                    <input type="text" id="NombreCliente" autoComplete='off' name="NombreCliente" placeholder="nombre o cédula sin guiones ni espacios" 
                    value={Gestor.NombreCliente} onChange={CambiaDatosGestor} onKeyDown={(e) => {
                        console.log(e.key);
                        if (e.key === 'Enter') {
                            e.preventDefault();
                            cargandoClientes();
                        }}}></input>
                 
                
                </div>
                   
                <div className="col-25">
                    <div className='row'>
                    <div className='col-50'>
                        <button id="Buscar" onClick={() => cargandoClientes()} name="Buscar">Buscar</button>
                    </div>
                    <div className='col-50'>
                        <button id="Buscar" onClick={() => Avance('')} name="Buscar">Nuevo</button>
                    </div>
                    </div>

                </div>
                <div className="col-25"></div>
                </div>

                <div className="info" style={{ overflowX: 'auto' }}>
                <table id="tablaClientes" name="tablaClientes" className="table-striped table table-sm'">
                    <thead>
                    <tr>
                        <th style={{ textAlign: 'center' }}></th>
                        <th style={{ textAlign: 'center' }}>Cédula</th>
                        <th style={{ textAlign: 'center' }}>Nombre</th>
                    </tr>
                    </thead>
                    <tbody>
                    {LosClientes.map((post, index) => {
                        return <tr key={index}>
                        {/*   <td> <input type='checkbox' disabled={post.Estado !== 'Sin Cargar a SAP'} onChange={() => ClicCheckTabla(post.ConsecutivoProveedor, post.CedulaPR)} ></input> </td> */}
                        <td><button onClick={() => Avance(post.FAC_CED_CLI)} >Modificar</button></td>
                        <td>{post.FAC_CED_CLI}</td>
                        <td>{post.FAC_NOMBRE}</td>
                        </tr>
                    })}
                    </tbody>
                </table>



                </div>

            </div>


            </div>
        </div>
    }
    else {
        return <p>Cargando Proceso Cliente...</p>
    }

}
export default GeneralCliente;